import type { DraftState } from '../types';
import { TeamLogo } from './TeamLogo';

interface Props {
  state: DraftState;
}

export function DraftHistory({ state }: Props) {
  const total = state.rosterCap * state.managers.length;
  return (
    <div className="panel p-4 max-h-[600px] overflow-y-auto">
      <h2 className="text-lg font-extrabold text-white mb-3">
        📜 History <span className="text-slate-400 text-sm font-normal">({state.history.length} / {total})</span>
      </h2>
      {state.history.length === 0 && (
        <p className="text-slate-500 italic text-sm">No picks yet.</p>
      )}
      <ul className="space-y-1.5">
        {state.history.map(h => (
          <li
            key={`${h.round}-${h.team}`}
            className="flex items-center gap-3 p-2 bg-slate-800/50 rounded-lg border-l-4 border-teal-500"
          >
            <span className="text-xs font-mono text-slate-500 w-8">#{h.round}</span>
            <TeamLogo abbr={h.team} size={28} />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-white truncate">{h.team}</div>
              <div className="text-[10px] text-slate-400">won by {h.winner}</div>
            </div>
            <div className="text-emerald-400 font-extrabold">${h.price}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
